export default __webpack_public_path__ + "static/media/02_photo.bf0c310f.jpg";